module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dana L. Robert, Christine D. Pohl\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Dana L. Robert")]), _vm._v(" is Truman Collins Professor of World Christianity and History of Mission at the Boston University School of Theology. She has published widely on mission history, world Christianity, and African Christianity, including "), _c('I', [_vm._v("Christian Mission: How Christianity Became a World Religion.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6nFHbY/tc-custom/9781467457064.jpg?1730409956819",
      "alt": "This image is the cover for the book Faithful Friendships"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Faithful Friendships\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("On the necessity of boundary-crossing friendships for Christian discipleship")])]), _c('p', [_vm._v("Friendship isn’t always given a lot of thought—and lately, it doesn’t get a lot of time and effort, either. But in a world of busy and isolated lives, in which friendships can too easily become shallow, tenuous, and homogeneous, Dana Robert insists that good friendships are a vital and transformative part of the Christian life—a mustard seed of the kingdom of God. She believes Christians have the responsibility—and opportunity—to be countercultural by making friends across cultural, racial, socioeconomic, and religious lines that separate people from each other.")]), _c('p', [_vm._v("In this book Robert tells the stories of Christians who, despite or even because of difficult circumstances, experienced friendship with people unlike themselves as “God with us,” as exile, as testimony, and as celebration.")]), _c('p', [_vm._v("Jesus was a "), _c('i', [_vm._v("friend ")]), _vm._v("to his disciples. Through Jesus’s life and the lives of his followers down through the ages, "), _c('i', [_vm._v("Faithful Friendships ")]), _vm._v("shows readers how friendship can become life-changing—and even worldchanging.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0